module.exports = __webpack_public_path__ + "static/edet-d03c73fc5e06c0b6216ec2edb7686191.png";